import { HttpMethod } from '../types.js';
export const ApiDef_Archiving = {
    vv1: {
        hardDeleteAll: { method: HttpMethod.GET, path: 'v1/archiving/hard-delete-all' },
        hardDeleteUnique: { method: HttpMethod.POST, path: 'v1/archiving/hard-delete-unique' },
        getDocumentHistory: { method: HttpMethod.GET, path: 'v1/archiving/get-document-history' }
    }
};
//# sourceMappingURL=apis.js.map